import { useState } from "react";
import { toast } from "sonner";
import { Share2, Link2, Download, MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { API } from "@/lib/api";

export const ShareButton = ({ event, className = "" }) => {
  const [busy, setBusy] = useState(false);
  const shareUrl = `${API}/share/e/${event.id}`;
  const text = `Ada fotomu di ${event.title}? Cari pakai swafoto di Akudifoto: ${shareUrl}`;

  const copy = async () => {
    await navigator.clipboard?.writeText(shareUrl);
    toast.success("Link disalin");
  };

  const storyFile = async () => {
    const blob = await (await fetch(`${API}/share/e/${event.id}/story.jpg`)).blob();
    return new File([blob], "akudifoto-event.jpg", { type: "image/jpeg" });
  };

  const instagram = async () => {
    setBusy(true);
    try {
      const file = await storyFile();
      if (navigator.canShare?.({ files: [file] })) {
        await navigator.share({ files: [file], text });
      } else {
        const url = URL.createObjectURL(file);
        const a = document.createElement("a");
        a.href = url;
        a.download = file.name;
        a.click();
        setTimeout(() => URL.revokeObjectURL(url), 2000);
        toast.success("Gambar diunduh. Unggah ke Instagram Story atau Feed.");
      }
    } catch (e) {
      if (e?.name !== "AbortError") toast.error("Gagal menyiapkan gambar");
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button variant="outline" className={`rounded-xl h-11 bg-white ${className}`} data-testid="share-event-button"><Share2 className="mr-2 h-4 w-4" />Bagikan</Button>
      </DialogTrigger>
      <DialogContent className="rounded-2xl max-w-lg" aria-describedby={undefined} data-testid="share-dialog">
        <DialogHeader><DialogTitle>Bagikan event</DialogTitle></DialogHeader>
        <img src={`${API}/share/e/${event.id}/og.jpg`} alt="Pratinjau kartu bagikan" className="w-full rounded-xl border border-zinc-200 aspect-[1200/630] object-cover bg-zinc-100" data-testid="share-preview-image" />
        <p className="text-xs text-zinc-500">Pratinjau ini muncul otomatis saat link dibagikan di WhatsApp, Facebook, Telegram, atau X.</p>
        <div className="grid grid-cols-2 gap-2">
          <Button asChild className="rounded-xl h-11 bg-[#25D366] hover:bg-[#1ebe5b] text-white" data-testid="share-whatsapp-button">
            <a href={`https://wa.me/?text=${encodeURIComponent(text)}`} target="_blank" rel="noreferrer"><MessageCircle className="mr-2 h-4 w-4" />WhatsApp</a>
          </Button>
          <Button onClick={instagram} disabled={busy} className="rounded-xl h-11 bg-zinc-900 hover:bg-zinc-800" data-testid="share-instagram-button">
            <Download className="mr-2 h-4 w-4" />{busy ? "Menyiapkan..." : "Gambar Instagram"}
          </Button>
        </div>
        <div className="flex gap-2">
          <input readOnly value={shareUrl} className="flex-1 h-10 rounded-xl border border-zinc-200 bg-zinc-50 px-3 text-xs font-mono-x text-zinc-600" data-testid="share-link-input" />
          <Button variant="outline" onClick={copy} className="rounded-xl h-10" data-testid="share-copy-button"><Link2 className="mr-1.5 h-4 w-4" />Salin</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
